import {component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {OutletReferenceData} from "../outlet/outlet.data";
import {PriceLevelReferenceData} from "../../pricing/price-level/price-level.data";
import {FunctionBarData} from "../function-bar/function-bar.data";
import {TerminalReferenceData} from "./terminal-reference.data";

export class FunctionalTerminalData extends EntityData<FunctionalTerminalData> {
    @component standardTerminal: TerminalReferenceData;
    @field terminalFunction: string;
}

export class TerminalData extends EntityData<TerminalData> {

    static readonly STANDARD_TYPE: string = "STANDARD";
    static readonly FUNCTIONAL_TYPE: string = "FUNCTIONAL";
    static readonly HANDHELD_TYPE: string = "HANDHELD";

    @identifier terminalId: number;
    @field name: string;
    @field description: string;
    @field configurationId: number;
    @field type: string = TerminalData.STANDARD_TYPE;
    @field orderNumberPrefix: string;
    @component priceLevel: PriceLevelReferenceData;
    @component outlet: OutletReferenceData;
    @component functionBar: FunctionBarData;
    @component functionalTerminal: FunctionalTerminalData;
}

